import type { FilterOption } from "@/types";

export interface FilterGroup {
  key: string;
  label: string;
  options: FilterOption[];
  icon?: string;
}

interface FilterPanelProps {
  groups: FilterGroup[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  onReset: () => void;
}

export default function FilterPanel({
  groups,
  values,
  onChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="space-y-6">
      {groups.map((group) => (
        <div key={group.key}>
          <h3 className="flex items-center gap-1.5 text-sm font-medium text-foreground-900 mb-3">
            {group.icon && <i className={`${group.icon} text-foreground-500`}></i>}
            {group.label}
          </h3>
          <div className="flex flex-wrap gap-2">
            {group.options.map((opt) => {
              const active = values[group.key] === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => onChange(group.key, opt.value)}
                  className={`px-3 py-1.5 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
                    active
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={onReset}
        className="w-full h-10 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-1.5"
      >
        <i className="ri-refresh-line"></i>
        重置筛选
      </button>
    </div>
  );
}